// extracted by mini-css-extract-plugin
export default {"headerContainer":"roxDd","header":"_2Zv8M","left":"DqglB","menuButton":"rdXTU","profile":"Vc1sj"};